export const GET_GROUP_ROLE_LIST = 'cf02-roles/cf021-get-listrolesgroup';
export const UPDATE_GROUP_ROLE_LIST = 'cf02-roles/cf022-update-listrolesgroup';

export const GET_ACCOUNT_LIST = 'cf01-account/cf011-get-list';
export const INVITE_ACCOUNT = 'cf01-account/cf012-invite-account';
export const UPDATE_ACCOUNT = 'cf01-account/cf013-update';
export const DELETE_ACCOUNT = 'cf01-account/cf016-delete';
export const UPDATE_STATUS_ACCOUNT = 'cf01-account/cf015-update-usersitestatus';
